import Iconify from "../Components/Dashboard/Iconify";

// ----------------------------------------------------------------------

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;


const logoutHandler = () => {
  window.location.replace('/login');
  localStorage.removeItem('user');
  localStorage.removeItem("expirationTime");
};

const sidebarConfig = [
  {
    title: "dashboard",
    path: "/home/dashboard",
    icon: getIcon('ant-design:pie-chart-outlined'),
    roles: ['SAED_LGI', 'SAED_State', 'SAED_State_Coordinator', 'State Cordinator', 'SAED_NDHQ', 'Default']
    // roles: 'all',
  },
  {
    title: "user management",
    path: "/home/usermanagement",
    icon: getIcon('la:user-cog'),
    roles: ['SAED_LGI', 'SAED_State', 'SAED_State_Coordinator', 'State Cordinator', 'SAED_NDHQ', 'Default'],
    // roles: 'all',
  },
  {
    title: "skills management",
    path: "/home/skillsetmanagement/setup",
    icon: getIcon('eva:bar-chart-2-fill'),
    roles: ['SAED_LGI', 'SAED_State', 'SAED_State_Coordinator', 'State Cordinator', 'SAED_NDHQ', 'Default'],
    // roles: 'all',
  },
  {
    title: "partner management",
    path: "/home/partnermanagement",
    icon: getIcon('fluent:people-team-16-regular'),
    roles: ['SAED_NDHQ'],
  },
  {
    title: "loan management",
    path: "home/loanmanagement",
    icon: getIcon('fluent-emoji-high-contrast:money-bag'),
    roles: ['SAED_LGI', 'SAED_State', 'SAED_State_Coordinator', 'State Cordinator', 'SAED_NDHQ', 'Default'],
    // roles: 'all',
    children: [
      {
        title: "loan setup",
        path: "/home/loanmanagement/loansetup",
        icon: "*",
        roles: 'all',
      },
      {
        title: "Track Loan Beneficiary",
        path: "/home/loanmanagement/loanstatus",
        icon: "*",
        roles: 'all',
      },
    ],
  },
  {
    title: "trainers management",
    path: "/home/trainersmanagement",
    icon: getIcon("la:chalkboard-teacher"),
    roles: ['SAED_LGI', 'SAED_State', 'SAED_State_Coordinator', 'State Cordinator', 'SAED_NDHQ', 'Default'],
    // roles: 'all',
    children: [
      {
        title: "Trainers Listing",
        path: "/home/trainersmanagement/trainersListing",
        icon: "*",
        roles: ['SAED_NDHQ']
      },
      {
        title: "Virtual Approval",
        path: "/home/trainersmanagement/virtualApproval",
        icon: "*",
        roles: 'all',
      },
      {
        title: "Physical Approval",
        path: "/home/trainersmanagement/physicalApproval",
        icon: "*",
        roles: 'all',
      },
    ]
  },
  // {
  //   title: "skills acquisition centre",
  //   path: "/home/skillacquisitioncentre",
  //   icon: getIcon("fluent-emoji-high-contrast:building-construction"),
  //   roles: ['SAED_NDHQ'],
  // },
  {
    title: "Business Management",
    path: "/home/managesuccessfulbusiness",
    icon: getIcon("fluent-mdl2:recruitment-management"),
    roles: ['SAED_LGI', 'SAED_State', 'SAED_State_Coordinator', 'State Cordinator', 'SAED_NDHQ', 'CORP_MEMBER', 'Default'],
    // roles: 'all',
  },
  {
    title: "Manage Success Stories",
    path: "/home/managesuccessstories",
    icon: getIcon("ph:chart-line-bold"),
    roles: ['SAED_LGI', 'SAED_State', 'SAED_State_Coordinator', 'State Cordinator', 'SAED_NDHQ', 'Default'],
    // roles: 'all',
  },
  {
    title: "Corps Member",
    path: "/home/cmMgtModule",
    icon: getIcon("material-symbols:manage-accounts-outline-rounded"),
    roles: ['CORP_MEMBER', 'State Cordinator', 'SAED_NDHQ', 'SAED_State'],
    children: [
      {
        title: "In-Camp Training Registration",
        path: "/home/cmMgtModule/inCampTrainingForm",
        icon: "*",
        roles: ['CORP_MEMBER']
      },
      {
        title: "In-Camp Activities",
        path: "/home/cmMgtModule/manageInCampActivities",
        icon: "*",
        roles: ['State Cordinator', 'SAED_NDHQ', 'SAED_State']
      },
      {
        title: "Post-Camp Activities",
        path: "/home/cmMgtModule/managePostCampActivities",
        icon: "*",
        roles: ['State Cordinator', 'SAED_NDHQ', 'SAED_State']
      },

    ]
  },
  // {
  //   title: "Monitoring and Evaluation",
  //   path: "/home/monitoringandevaluation/dashboard",
  //   icon: getIcon("wpf:inspection"),
  //   roles: 'all',
  // },
  {
    title: "Site Settings",
    path: "/home/systemSettings",
    icon: getIcon("material-symbols:settings"),
    roles: ['SAED_NDHQ'],
  },
  {
    title: "logout",
    path: "/login",
    icon: getIcon("humbleicons:logout"),
    onLogoutClick: () => logoutHandler(),
    roles: 'all',
  },
];

export default sidebarConfig;
